import { Header } from "./components/header/Header";
import { HomePage } from "./pages/homePage/HomePage";
import "./index.css";

function App() {
  return (
    <>
      <Header />
      <HomePage />
    </>
  );
}

export default App;
